module.exports = __webpack_public_path__ + "media/images/flags/gm-740c26dadddb364dd805beecafc911c5.svg";